import { ToastName } from '../../../constants/app';
import { surfaceContextWithPropertiesHook } from '../../../hooks/context/common';
import {
    ErrorToastContext,
    InfoToastContext,
    InProgressToastContext,
    SuccessToastContext,
    ToastProperties,
    WarningToastContext,
} from '../contexts/toast-contexts';

// Default handlers for toast management
const defaultCloseToast = (_toastType: string) => () => {
    // Toast close handlers will be managed by the context providers
};

const defaultOpenToast = (_toastType: string) => (_properties?: ToastProperties) => {
    // Toast open handlers will be managed by the context providers
};

// Hook implementations
export const useInfoToastContext = surfaceContextWithPropertiesHook(
    InfoToastContext,
    defaultOpenToast(ToastName.Info),
    defaultCloseToast(ToastName.Info),
    {
        children: '',
    }
);

export const useSuccessToastContext = surfaceContextWithPropertiesHook(
    SuccessToastContext,
    defaultOpenToast(ToastName.Success),
    defaultCloseToast(ToastName.Success),
    {
        children: '',
    }
);

export const useErrorToastContext = surfaceContextWithPropertiesHook(
    ErrorToastContext,
    defaultOpenToast(ToastName.Error),
    defaultCloseToast(ToastName.Error),
    {
        children: '',
    }
);

export const useWarningToastContext = surfaceContextWithPropertiesHook(
    WarningToastContext,
    defaultOpenToast(ToastName.Warning),
    defaultCloseToast(ToastName.Warning),
    {
        children: '',
    }
);

export const useInProgressToastContext = surfaceContextWithPropertiesHook(
    InProgressToastContext,
    defaultOpenToast(ToastName.InProgress),
    defaultCloseToast(ToastName.InProgress),
    {
        children: '',
    }
);
